module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ./~/kea-saga/~/babel-runtime/regenerator/index.js
// module id = 112
// module chunks = 2